import mixin from "./yearCalculations.js";
export default {
    name: "timeline",
    mixins: [mixin],
    methods: {
        alphabetize: function(data) {
            let array = data.sort((a, b) => {
                if (a[1] < b[1]) {
                    return -1;
                } else if (a[1] > b[1]) {
                    return 1;
                }
                return 0;
            });
            return array;
        },
        loadCountries: function(query) {
          if (!this.$global.timelineCountries) {
            let baseURL = `${process.env.VUE_APP_DXA_ENDPOINT}/events/countries?hash=${process.env.VUE_APP_API_HASH}`;
            let fullURL;
            if (query === "" || query === "all") {
                fullURL = baseURL;
            } else {
                fullURL = baseURL + "&ic[]=" + query;
            }
            return axios({ method: "GET", "url": fullURL }).then(result => {
                let objects = result.data.items;
                let array = [];
                for (let entry in objects) {
                    let subArray = [];
                    for (let key in objects[entry]) {
                        subArray.push(objects[entry][key]);
                    }
                    array.push(subArray);
                }
                let alphabetized = this.alphabetize(array);
                alphabetized.unshift(["all", "All Countries"]);
                this.$global.timelineCountries = alphabetized;
                this.countries = alphabetized;
            }, error => {
                console.error(error);
            });
          } else {
            this.countries = this.$global.timelineCountries;
            return Promise.resolve();
          }
        },
        loadYears: function(queries) {
          if (!this.$global.timelineYears) {
            return axios({ method: "GET", "url": `${process.env.VUE_APP_DXA_ENDPOINT}/events/years?hash=${process.env.VUE_APP_API_HASH}&${queries}` }).then(result => {
                let min = parseInt(result.data.minYear);
                let max = parseInt(result.data.maxYear);
                let increments = [500, 250, 100, 50];
                let smallestIncrement;
                let array = [min];
                let minRounded, maxRounded;

                if (max >= 1800) {
                    maxRounded = this.getPreviousMultiple(max, increments[3]);
                } else if (max >= 1000) {
                    maxRounded = this.getPreviousMultiple(max, increments[2]);
                } else if (max >= 0) {
                    maxRounded = this.getPreviousMultiple(max, increments[1]);
                } else if (max < 0) {
                    maxRounded = this.getPreviousMultiple(max, increments[0]);
                }
                if (min <= 0) {
                    minRounded = this.getNextMultiple(min, increments[0]);
                } else if (min <= 1000) {
                    minRounded = this.getNextMultiple(min, increments[1]);
                } else if (min <= 1800) {
                    minRounded = this.getNextMultiple(min, increments[2]);
                } else if (min > 1800) {
                    minRounded = this.getNextMultiple(min, increments[3]);
                }

                do {
                    if (minRounded < 0) {
                        this.pushIncrements(minRounded, maxRounded, 0, increments[0], array);
                        minRounded = array[array.length - 1];
                        smallestIncrement = increments[0];
                    } else if (minRounded < 1000) {
                        this.pushIncrements(minRounded, maxRounded, 1000, increments[1], array);
                        minRounded = array[array.length - 1];
                        smallestIncrement = increments[1];
                    } else if (minRounded < 1800) {
                        this.pushIncrements(minRounded, maxRounded, 1800, increments[2], array);
                        minRounded = array[array.length - 1];
                        smallestIncrement = increments[2];
                    } else if (minRounded >= 1800) {
                        this.pushIncrements(minRounded, maxRounded, maxRounded, increments[3], array);
                        minRounded = array[array.length - 1];
                        smallestIncrement = increments[3];
                    }
                } while (array[array.length - 1] < maxRounded);

                array.push(max);
                array = [...new Set(array)];
                let yearsWithLabels = [];
                // skips 0 currently
                for (let i = 0; i < array.length; i++) {
                    if (array[i] < 0) {
                        yearsWithLabels.push([array[i], Math.abs(array[i]) + " B.C."]);
                    } else if (array[i] > 0) {
                        yearsWithLabels.push([array[i], array[i] + " A.D."]);
                    }
                }

                let before1000BC = false;
                if (yearsWithLabels[0][0] < -1000) {
                    before1000BC = true;
                }
                let displayYears = [];
                if (before1000BC) {
                    for (let j = 0; j < yearsWithLabels.length; j++) {
                        if (yearsWithLabels[j][0] < -1000) {
                            continue;
                        } else {
                            displayYears.push(yearsWithLabels[j]);
                        }
                    }
                    displayYears.unshift([min, "Before 1000 B.C."]);
                } else {
                    displayYears = yearsWithLabels;
                }

                let y = displayYears;
                if (y[y.length - 1][0] - y[y.length - 2][0] < smallestIncrement) {
                    displayYears[displayYears.length - 1][1] = `After ${displayYears[displayYears.length - 2][1]}`;
                }
                this.$global.timelineYears = displayYears;
                this.years = displayYears;
            }, error => {
                console.error(error);
            });
          } else {
            this.years = this.$global.timelineYears;
            return Promise.resolve();
          }
        },
    }
}